import React, { useEffect, useState } from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import CookieStrip from "components/CookieStrip";

function Layout({ children }) {
  const [cookieSrtip, setCookieStrip] = useState(false);
  useEffect(() => {
    const value = localStorage.getItem("cookie");
    if (value !== "true") {
      setTimeout(() => {
        setCookieStrip(true);
      }, 2000);
    }
  }, []);

  return (
    <>
      <Header />
      {children}
      <Footer />
      {cookieSrtip && <CookieStrip setCookieStrip={setCookieStrip} />}
    </>
  );
}
export default Layout;
